/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_TitleInputs */

const vi_warehouse_defects_title = /** @type {(inputs: Warehouse_Defects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản phẩm đóng lỗi`)
};

/**

* @param {Warehouse_Defects_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_title = /** @type {((inputs?: Warehouse_Defects_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_title(inputs)
});